module.exports = __webpack_public_path__ + "images/_/javascripts/components/modal/guidance_slider_modal/images/fourth_e6d88eafbe35e70e67a47fd3e9f1f236.png";